import { excuseApi } from "../commons/http";

class Inventory {
  constructor(data = {}) {
    this.id = data.id;
    this.product_id = data.product_id;
    this.transaction_type = data.transaction_type;
    this.happened_at = data.happened_at;
    this.description = data.description;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.product = data.product;
    this.quantity = data.quantity;
    this.created_by_account_id = data.created_by_account_id;
    this.created_by = data.created_by;
  }
  mapData(data) {
    this.id = data.id;
    this.product_id = data.product_id;
    this.transaction_type = data.transaction_type;
    this.happened_at = data.happened_at;
    this.description = data.description;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.product = data.product;
    this.quantity = data.quantity;
    this.created_by_account_id = data.created_by_account_id;
    this.created_by = data.created_by;
  }

  async addInventoryLevelTransactions() {
    try {
      const res = await excuseApi({
        path: '/inventory_level_transactions',
        method: 'POST',
        body: {
          product_id: this.product_id,
          quantity: this.quantity,
          transaction_type: this.transaction_type,
        }
      })
      if (res.status === 201 || res.status === 200) {
        return { success: true, messenge: "Thêm đơn nhập hàng thành công" }
      }
      else {
        return { success: false, message: "Không thể thêm đơn nhập hàng. Vui lòng thử lại." };
      }
    }
    catch (error) {
      throw error;
    }
  }

  async getInventoryLevelTransactionsById(id) {
    try {
      const res = await excuseApi({
        path: `/inventory_level_transactions/${id}`,
        method: 'GET'
      })
      if (res.status === 200 || res.status === 201) {
        return res.data.data;
      }
    }
    catch (error) {
      throw error;
    }
  }

  async updateInventoryLevelTransactionsById(id) {
    try {
      const res = await excuseApi({
        path: `/inventory_level_transactions/${id}`,
        method: 'PUT',
        body: {
          product_id: this.product_id,
          quantity: this.quantity,
          transaction_type: 'addition',
        }
      })
      if (res.status === 200 || res.status === 201) {
        return { success: true, messenge: "Chỉnh sửa đơn nhập hàng thành công" };
      }
      else {
        return { success: false, message: "Chỉnh sửa đơn nhập hàng thất bại. Vui lòng thử lại." };
      }
    }
    catch (error) {
      throw error;
    }
  }
}

export default Inventory;
